import { http, HttpResponse } from 'msw';

const mockBindSearchTag = [
  http.post(`${process.env.BFF_URL}truckers/bind-search-tag`, () => new HttpResponse(null, { status: 200 })),
];

export { mockBindSearchTag };
